import { forwardRef } from 'react';

import {
  Typography,
  TypographyProps,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {},
});

type LabelProps = Omit<TypographyProps, 'classes'> &
  WithStyles<typeof styles> & {
    disableTypography?: boolean;
  };

const Label = forwardRef<HTMLSpanElement, LabelProps>((props, ref) => {
  const { classes, className, disableTypography, children, ...other } = props;

  if (disableTypography) {
    return (
      <span
        ref={ref}
        className={classNames(classes.root, className)}
        {...other}
      >
        {children}
      </span>
    );
  }

  return (
    <Typography
      ref={ref}
      className={classNames(classes.root, className)}
      component="span"
      {...other}
    >
      {children}
    </Typography>
  );
});

Label.displayName = 'StateIcon.Label';

export default withStyles(styles)(Label);
